var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83145 14.0525C1.56651 14.1113 1.33841 14.045 1.14716 13.8538C0.955926 13.6625 0.88969 13.4345 0.948454 13.1695L1.64556 9.82341L5.17756 13.3554L1.83145 14.0525ZM5.17756 13.3554L1.64556 9.82341L10.9949 0.474051C11.2823 0.186662 11.6381 0.0429688 12.0622 0.0429688C12.4863 0.0429688 12.8421 0.186662 13.1295 0.474051L14.5269 1.87147C14.8143 2.15886 14.958 2.51462 14.958 2.93876C14.958 3.3629 14.8143 3.71866 14.5269 4.00605L5.17756 13.3554ZM11.8859 1.35224L3.36508 9.86505L5.13591 11.6359L13.6487 3.11505C13.6968 3.06697 13.7208 3.00687 13.7208 2.93476C13.7208 2.86263 13.6968 2.80253 13.6487 2.75445L12.2465 1.35224C12.1984 1.30416 12.1383 1.28011 12.0662 1.28011C11.9941 1.28011 11.934 1.30416 11.8859 1.35224Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.40b10c5a2bc153a7e73caa05ffe52bbd.svg";
export { ForwardRef as ReactComponent };